exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.forRejection {\n  margin: 1ex;\n  padding: 1ex;\n  border: 3px double red;\n}\n\ndiv.recordDisplay {\n  padding: 0.8ex;\n  margin-left: 2em;\n  font-size: 90%;\n}\n\ndiv.menu {\n  padding: 8px;\n  text-align: center;\n  font-weight: bold;\n}\n\ndiv.results {\n  border-top: thick double black;\n  padding: 1ex;\n}\n\ndiv.menu button {\n  font-weight: bold;\n}\n\ndiv.recordDisplay {\n  margin-top: 1ex;\n  padding-top: 1ex;\n  border-top: thin dotted silver;\n}\n\ndiv.source {\n  margin-bottom: 1ex;\n  padding-bottom: 1ex;\n  border-bottom: thin dotted silver;\n}\n\ndiv.rejectMenu {\n  text-align: center;\n}\n\ndiv.rejectMenu div.intro {\n  font-weight: bold;\n  margin-bottom: 1ex;\n  color:red;\n}\n\ndiv.rejectMenu button {\n  margin-right: 1ex;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/exclude-sources/exclude-sources.component.css
// module id = ../../../../../src/app/exclude-sources/exclude-sources.component.css
// module chunks = main